/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetUserByEmailRequest
 */
export interface GetUserByEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof GetUserByEmailRequest
     */
    email: string;
}

/**
 * Check if a given object implements the GetUserByEmailRequest interface.
 */
export function instanceOfGetUserByEmailRequest(value: object): value is GetUserByEmailRequest {
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function GetUserByEmailRequestFromJSON(json: any): GetUserByEmailRequest {
    return GetUserByEmailRequestFromJSONTyped(json, false);
}

export function GetUserByEmailRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUserByEmailRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
    };
}

export function GetUserByEmailRequestToJSON(json: any): GetUserByEmailRequest {
    return GetUserByEmailRequestToJSONTyped(json, false);
}

export function GetUserByEmailRequestToJSONTyped(value?: GetUserByEmailRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
    };
}

